import React, { useCallback, useEffect, useRef, useState } from 'react';
import TeachingMomentsSection from './TeachingMomentsSection';
import VideoPlansView from './VideoPlansView';
import AddToPlanSheet from './AddToPlanSheet';
import './TeachingsHub.css';

/**
 * The coach's teachings workspace: the Library (all teachings, sorted by skill, star the good ones) and Video plans
 * (short-video ideas built from them). Both stay mounted so switching keeps scroll and state.
 */
const TeachingsHub = ({ coachId }) => {
  const [view, setView] = useState('library'); // 'library' | 'plans'
  const [adding, setAdding] = useState(null);  // the teaching being added to a plan
  const [toast, setToast] = useState('');
  const [plansKey, setPlansKey] = useState(0); // bump to make the plans list reload
  const toastTimer = useRef(null);

  useEffect(() => () => clearTimeout(toastTimer.current), []);

  const showToast = useCallback((text) => {
    setToast(text);
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToast(''), 3200);
  }, []);

  const goTo = (next) => { setView(next); if (next === 'plans') setPlansKey(k => k + 1); };

  return (
    <div className="th-hub">
      <div className="th-seg" role="tablist" aria-label="Teachings">
        <button type="button" role="tab" aria-selected={view === 'library'} className={`th-seg-btn${view === 'library' ? ' is-active' : ''}`} onClick={() => goTo('library')}>📚 Library</button>
        <button type="button" role="tab" aria-selected={view === 'plans'} className={`th-seg-btn${view === 'plans' ? ' is-active' : ''}`} onClick={() => goTo('plans')}>🎬 Video plans</button>
      </div>

      <div hidden={view !== 'library'}>
        <TeachingMomentsSection coachId={coachId} onAddToPlan={setAdding} />
      </div>
      <div hidden={view !== 'plans'}>
        <VideoPlansView reloadKey={plansKey} />
      </div>

      {adding && (
        <AddToPlanSheet
          moment={adding}
          onClose={() => setAdding(null)}
          onAdded={(planTitle) => { setAdding(null); setPlansKey(k => k + 1); showToast(`Added to “${planTitle}”`); }}
        />
      )}
      {toast && <div className="th-toast" role="status">{toast}</div>}
    </div>
  );
};

export default TeachingsHub;
